import { render, staticRenderFns } from "./pageTwo.vue?vue&type=template&id=5faa6cbf"
import script from "./pageTwo.vue?vue&type=script&lang=js"
export * from "./pageTwo.vue?vue&type=script&lang=js"
import style0 from "./pageTwo.vue?vue&type=style&index=0&id=5faa6cbf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports